/* esm.sh - rxjs@7.8.2/dist/esm/internal/util/isDate */
function i(t){return t instanceof Date&&!isNaN(t)}export{i as isValidDate};
//# sourceMappingURL=isDate.mjs.map